"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { commentConfig } from "@/components/Comment/config/comment.config";
type CharacterCountProps = {
  readonly count: number;
};
export function CharacterCount(t0) {
  const $ = _c(8);
  const {
    count
  } = t0;
  const {
    maxLength
  } = commentConfig.form;
  const t1 = count >= maxLength && "text-error-400";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("font-medium text-xs tabular-nums", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count) {
    t3 = count.toLocaleString();
    $[2] = count;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = maxLength.toLocaleString();
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3) {
    t5 = <span aria-live="polite" className={t2}>{t3} / {t4}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}